"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.channels.title': 'Integraciones de canales',
    'socialMediaPlan.channels.desc': 'Conecta tus cuentas.',
};
